import { useEffect } from "react";
import { useSiteSettings } from "@/contexts/SettingsContext";

/**
 * Sync document title, meta description, OpenGraph and Twitter tags from site settings.
 * Mounted once near the root of the app.
 */
function setMetaContent(selector, value) {
  if (!value) return;
  const el = document.querySelector(selector);
  if (el) el.setAttribute("content", value);
}

export default function SiteHead() {
  const { settings } = useSiteSettings();

  useEffect(() => {
    const title = settings?.seo_title || settings?.app_name;
    if (title) {
      document.title = title;
      setMetaContent('meta[property="og:title"]', title);
      setMetaContent('meta[name="twitter:title"]', title);
    }

    const description = settings?.seo_description;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
      setMetaContent('meta[property="og:description"]', description);
      setMetaContent('meta[name="twitter:description"]', description);
    }

    const ogImage = settings?.hero_image || settings?.logo_image;
    if (ogImage) {
      setMetaContent('meta[property="og:image"]', ogImage);
    }
  }, [settings?.seo_title, settings?.seo_description, settings?.app_name, settings?.hero_image, settings?.logo_image]);

  useEffect(() => {
    const color = settings?.brand_primary;
    if (color && /^#[0-9a-fA-F]{6}$/.test(color)) {
      document.documentElement.style.setProperty("--brand-primary", color);
    }
  }, [settings?.brand_primary]);

  return null;
}
